module.exports = __webpack_public_path__ + "img/18_104.938aca7c.png";